// eslint-disable-next-line
export enum PageModeEnum {
  READ = 'READ',
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
}
